import { Link } from "react-router-dom";
import { BiChevronRight } from "react-icons/bi";

const ProjectCard = ({ project, index }) => (
  <Link
    to={`/projects/${project.slug}`}
    className="group flex flex-col sm:flex-row gap-5 py-6 border-b border-border hover:bg-surface/40 -mx-3 px-3 rounded-lg transition-colors"
  >
    {project.image ? (
      <div className="sm:w-64 aspect-video shrink-0 rounded-lg overflow-hidden border border-border bg-surface/40">
        <img
          src={project.image}
          alt={project.name}
          className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-300"
        />
      </div>
    ) : (
      <span className="hidden sm:block w-8 shrink-0 font-mono text-sm text-muted pt-1">
        {String(index + 1).padStart(2, "0")}
      </span>
    )}

    <div className="min-w-0 flex-1 flex flex-col justify-center">
      <div className="flex items-center gap-2">
        <h3 className="text-lg font-semibold text-white group-hover:text-accent transition-colors">
          {project.name}
        </h3>
        {project.kind === "contract" && (
          <span className="text-[10px] font-mono uppercase tracking-wide text-muted border border-border rounded px-1.5 py-0.5 shrink-0">
            Contract
          </span>
        )}
      </div>
      <p className="text-sm text-muted mt-1">{project.tagline}</p>
      <span className="inline-flex items-center gap-1 mt-3 text-sm text-muted group-hover:text-accent transition-colors">
        View more
        <BiChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
      </span>
    </div>
  </Link>
);

export default ProjectCard;
